import axios from '@/http';
import {
  ICollectionParams,
  INavigatorParams,
  ICustTrxLogParams,
  ITrackCdParams,
  ITemplateParams,
  IAdsListParams,
  IPromotionParams,
} from '@/types';

class Api {
  /**
   * 메인화면 컴포넌트 조회
   */
  getPage = async (params: ICollectionParams) => {
    const { data } = await axios.post('page', params);
    return data.result;
  };

  /**
   * 네이베이션 목록 조회
   */
  getNavigator = async (params: INavigatorParams) => {
    const { data } = await axios.post('navigator', params);
    return data.result;
  };

  /**
   * 프로모션 상세 조회
   */
  getPromotionDetail = async (params: IPromotionParams) => {
    const page = params.page === 'deposit' ? 'saving' : params.page;
    const { data } = await axios.post(`${page}/promotion`, params);
    return data.result;
  };

  /**
   * 템플릿 조회
   */
  getTemplate = async (params: ITemplateParams) => {
    const { data } = await axios.post('creative/template', params);
    return data.result;
  };

  /**
   * trackCd 발급
   */
  getTrackCd = async (params: ITrackCdParams) => {
    const { data } = await axios.post('track/unknown', params);
    return data.trackCd;
  };

  putCustTrxLog = async (params: ICustTrxLogParams) => {
    await axios.put('putCustTrxLog', params);
  };

  /*
   * Banner-List 갱신
   *
   * */
  getBannerList = async (params: IAdsListParams) => {
    const { data } = await axios.post('banner', params);
    return data.result;
  };

  /**
   * 사용자 거래로그 저장
   */
  postCustTrxLog = async (params: ICustTrxLogParams) => {
    try {
      const blob = new Blob([JSON.stringify(params)], { type: 'application/json' });
      navigator.sendBeacon(`${process.env.API_URL}putCustTrxLog`, blob);
    } catch (e) {
      await this.putCustTrxLog(params);
    }
  };
}

const api = new Api();
export default api;
